import React from 'react';
import { getStyle } from '../../components';
import { PropTypes } from 'prop-types';
import autobind from 'autobind-decorator';
import { SecondKillComp } from '../../widgets';
import { dateformat } from '../../utils';
import store from '../../store';
import './AppList.less';

/**
 * 商品列表 - 双列
 * @class AppList
 * @extends {React.Component<any, any>}
 */
class AppList extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'app-list'
    };

    dataType: any = {
        '11': '开始秒杀',
        '12': '开始抢购',
        '21': '结束秒杀',
        '22': '结束抢购'
    };

    // 显示的活动文字
    @autobind
    private _showText(promotStatus: any, type: any): any {
        const typeStr: string = `${promotStatus}${type}`;
        return this.dataType[typeStr];
    }

    // 跳转商品详情
    @autobind
    toAppDetail(data, e) {
        if (e.target.className !== 'app-listadd_car_icon') {
            if (this.props.toApptaile) {
                this.props.toApptaile(data.productId, data.skuCode, e);
            }
        }
    }

    render() {
        const {prefixCls, data, shopHomeJia, isApp, shareProc, isSpecial, date, promotStatus, type} = this.props;
        let style = getStyle(this.props);
        let isBClass = isApp ? '-b' : '';
        return (
            <div className={'top_box ' + prefixCls + isBClass} style={style}>
                <div
                    className={`${prefixCls}label-box`}
                    onClick={(e) => {
                        this.toAppDetail(data, e);
                    }}
                >
                    {
                        data.labelImgList && data.labelImgList.map((item, index) => {
                            return (
                                <img src={item} key={index} alt=""/>
                            );
                        })
                    }
                </div>
                {/* 列表主图片 */}
                <div
                    className={prefixCls + 'img_box cover_img_box'}
                    onClick={(e) => {
                        this.toAppDetail(data, e);
                    }}
                >
                    <img src={data.mastermap} alt=""/>
                    {promotStatus !== 0 && promotStatus !== null && type !== 0 &&
                    <div className={'home-kill-box'}>
                        <SecondKillComp
                            text={this._showText(promotStatus, type)}
                            date={dateformat(date / 1000, 'mm月dd日 HH:MM:ss')}
                        />
                    </div>}
                </div>
                {/* 商品简介 */}
                <div
                    className={prefixCls + 'main_box'}
                    style={{
                        marginTop: store.status.isShowHead ? '1rem' : '0.8rem',
                        paddingLeft: isSpecial ? '.8rem' : ''
                    }}
                    onClick={(e) => {
                        this.toAppDetail(data, e);
                    }}>
                    <div className={prefixCls + 'main_top' + isBClass}>
                        {data.brandsName}·{data.productName}
                    </div>
                    <div className={prefixCls + 'main_middle' + isBClass}>{data.productAd}</div>
                    <div className={prefixCls + 'product_price'}>
                        <span className={prefixCls + 'monye_icon'}>￥</span>
                        <span className={prefixCls + 'monye'}>{data.minPrice || data.price}</span>
                        <span className={prefixCls + 'market_price'}>￥{data.minMarkPrice || data.marketPrice}
                            <span className={prefixCls + 'market_price_line'}/>
                        </span>
                    </div>
                </div>
                {
                    isSpecial ?
                        (data.status == -1 && <div className={prefixCls + 'img_alerts'}>抢光了</div>)
                        :
                        (data.status == 11 && <div className={prefixCls + 'img_alerts'}>抢光了</div>)
                }
                {
                    data.virtual ?
                        ''
                        :
                        <div className={`${prefixCls}add_car_icon${isSpecial ? '-s' : ''}`} onClick={() => {
                            shopHomeJia(data);
                        }}/>
                }
                {/* 判断是不是专题来的 */}
                {
                    isSpecial && (
                        <div className={`${prefixCls}-item-btn-box`}>
                            {
                                isApp ?
                                    <div
                                        onClick={() => {
                                            shareProc(data);
                                        }}
                                        className={`${prefixCls}-share-earn`}
                                    >
                                        分享赚￥{data.commission}
                                        <img src={require('../../images/share-white.png')} alt=""/>
                                    </div>
                                    :
                                    <span onClick={(e) => {
                                        this.toAppDetail(data, e);
                                    }}>立即购买</span>
                            }
                        </div>
                    )
                }
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default AppList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/AppList.tsx